import { render, staticRenderFns } from "./shadow.vue?vue&type=template&id=1a142c79&scoped=true"
import script from "./shadow.vue?vue&type=script&lang=js"
export * from "./shadow.vue?vue&type=script&lang=js"
import style0 from "./shadow.vue?vue&type=style&index=0&id=1a142c79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a142c79",
  null
  
)

export default component.exports